import { Component, OnInit } from '@angular/core';
import { BaseWidgetSettingsComponent } from '../../widget/base/base-widget';
import { WidgetDataService } from '../../widget/data/widget-data.service';
import { DxFormModule, DxPopupModule } from 'devextreme-angular';
import { DxiItemModule } from 'devextreme-angular/ui/nested';
import { MachineInfoMainService } from 'src/app/shared/services/machine-info.service';
import { MachineInfo } from 'src/api/generated';
import { ICorrectorsWidgetConfig } from '../correctors-widget.component';

@Component({
  selector: 'app-correctors-settings',
  standalone: true,
  imports: [DxPopupModule, DxiItemModule, DxFormModule],
  templateUrl: './correctors-settings.component.html',
  styleUrl: './correctors-settings.component.scss'
})
export class CorrectorsSettingsComponent extends BaseWidgetSettingsComponent<ICorrectorsWidgetConfig> implements OnInit {

  protected selectOptions: Array<{name: string}> = [];
  
  constructor(
    widgetDataService: WidgetDataService<ICorrectorsWidgetConfig>, 
    private readonly _miSvc: MachineInfoMainService
  ) {
    super(widgetDataService);

    this.formData = {
      machineName: '',
      title: ''
    }
  }

  ngOnInit(): void {
    this._miSvc.dataSource.load().then((data: MachineInfo[]) => {
      this.selectOptions = data.map((r: MachineInfo) => {
        return { name: r.Name ?? '' };
      });

      if (this._miSvc.CurrentMachine?.Name && this.formData && this.formData.machineName === '') {
        this.formData.machineName = this._miSvc.CurrentMachine.Name;
      }
    });
  }

  /**
   * Form submit method with validation.
   *
   * @memberof CorrectorsSettingsComponent
   */
  public override onSubmitModal(): void {
    if (this.formData) {
      this.formData.title = 'Correctors';
      this.formData.subtitle = this.formData.machineName;
    }
    super.onSubmitModal();
  }
}
